export default "__VITE_PUBLIC_ASSET__a2ca436e__"